<template>
  <fieldset
    :class="['p2a-select-input','p2a-fieldset-' + name, {'p2a-requires-input': required,
                                                         'p2a-input-error': error}]"
  >
    <label
      :for="'input-'+ name"
      class="p2a-input-label p2a-styled-select">
      {{ label }}
      <select
        :name="name"
        :id="'input-' + name"
        :autocomplete="autocompleteProps"
        :class="['form-control', { 'select-default' : titleDefaultSelected }]"
        :value="value"
        v-on="$listeners">
        <option
          v-if="defaultEmptyLabel"
          value="">{{ defaultEmptyLabel }}</option>
        <option
          v-for="(option, index) in options"
          :value="option.value"
          :key="index">{{ option.label }}
        </option>
      </select>
    </label>
    <span
      v-show="error"
      class="p2a-error-message">{{ error }}</span>
  </fieldset>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FieldSelect",
  props: {
    autocompleteProps: {
      type: String,
      default: ""
    },
    defaultEmptyLabel: {
      type: String,
      default: ""
    },
    error: {
      type: [String, Boolean],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    name: {
      required: true,
      type: String
    },
    options: {
      required: true,
      type: Array
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters({
      titleDefaultSelected: "forms/titleDefaultSelected"
    })
  }
};
</script>
